const AppWindow = () => window;
export default AppWindow;
